var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<redi-window-frame>\n<rt-global-settings></rt-global-settings>\n</redi-window-frame>\n";
var id1="ui/globalSettings.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./app/ui/globalSettings.html
// module id = 145
// module chunks = 0